import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import HeaderComponent from "@components/common/Header/Header";
import BackIcon from "@styles/all-images/icons/back-button.svg";
import ArrowDown from "@styles/all-images/icons/arrow-down.svg";
import SearchIcon from "@styles/all-images/icons/search.svg";
import PlusIcon from "@styles/all-images/icons/plus.svg";
import ArrowLeftIcon from "@styles/all-images/icons/arrow-left.svg";
import ArrowRightIcon from "@styles/all-images/icons/arrow-right.svg";
import ArrowDownIcon from "@styles/all-images/icons/chevron-down.svg";
import EyeIcon from "@styles/all-images/icons/eye-blue.svg";
import CheckBlueIcon from "@styles/all-images/icons/checkblue.svg";
import CloseRedIcon from "@styles/all-images/icons/closered.svg";
import InfoIcon from "@styles/all-images/icons/info.svg";
import EditIconBlue from "@styles/all-images/icons/edit-icon-blue.svg";
import TierConfigurationRejectionReason from "./TierConfigurationRejectionReason";
import TierRejectionReason from "./TierRejectionReason";
const TierConfigurationModule = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);

  const tierData = [
    {
      supertrader: "Mark Robinson",
      tsDocument: "Terms Sheet Document 1",
      createdBy: "Anele Ndlovu",
      createdOn: "03/12/2024 09:30",
      approvalStatus: "-",
      approvedBy: "Pending",
    },
    {
      supertrader: "Patricia Wilson",
      tsDocument: "Terms Sheet Document 2",
      createdBy: "Thabo Dlamini",
      createdOn: "03/12/2024 08:50",
      approvalStatus: "Anele Ndlovu",
      approvedBy: "Approved",
    },
    {
      supertrader: "Sophia Turner",
      tsDocument: "Terms Sheet Document 3",
      createdBy: "Zanele Masinga",
      createdOn: "02/12/2024 18:15",
      approvalStatus: "John Doe",
      approvedBy: "Rejected",
    },
    {
      supertrader: "James Taylor",
      tsDocument: "Terms Sheet Document 4",
      createdBy: "Sipho Khumalo",
      createdOn: "02/12/2024 14:40",
      approvalStatus: "-",
      approvedBy: "Pending",
    },
    {
      supertrader: "Mason Wright",
      tsDocument: "Terms Sheet Document 5",
      createdBy: "Zanele Masinga",
      createdOn: "02/12/2024 10:25",
      approvalStatus: "-",
      approvedBy: "Pending",
    },
  ];

  const filteredData = tierData.filter((tier) =>
    Object.values(tier).some((value) =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase()),
    ),
  );

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentData = filteredData.slice(startIndex, endIndex);

  const [isRejectionModalOpen, setIsRejectionModalOpen] = useState(false);
  const [isRejectionReasonModalOpen, setIsRejectionReasonModalOpen] =
    useState(false);
  const [isRightOpen, setIsRightOpen] = useState(false);
  const [selectedRightValue, setRightSelectedValue] = useState("5");

  const righttoggleDropdown = () => {
    setIsRightOpen(!isRightOpen);
  };

  const righthandleOptionClick = (value: string) => {
    setRightSelectedValue(value);
    setIsRightOpen(false);
  };

  const handleOpenRejectionModal = () => {
    setIsRejectionModalOpen(true);
  };

  const handleCloseRejectionModal = () => {
    setIsRejectionModalOpen(false);
  };

  const handleRejectionSubmit = () => {
    setIsRejectionModalOpen(false);
  };

  const handleOpenRejectionReasonModal = () => {
    setIsRejectionReasonModalOpen(true);
  };

  const handleCloseRejectionReasonModal = () => {
    setIsRejectionReasonModalOpen(false);
  };

  const navigate = useNavigate();

  return (
    <div className="tw-relative">
      <HeaderComponent />
      <div className="tw-fixed tw-h-[68px] tw-top-[80px] tw-w-full tw-z-10">
        <div className="tw-px-8 tw-py-4 tw-bg-white tw-border-b tw-border-[#E9EAEB]">
          <div className="tw-flex tw-justify-between tw-items-center">
            <div className="tw-flex tw-items-center">
              <a href="/">
                <img src={BackIcon} alt="Back Icon" />
              </a>
              <h1 className="tw-text-[22px] tw-ml-4 tw-font-semibold tw-text-[#232323]">
                Tire Configuration
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="tw-p-6 tw-mt-[147px]">
        <div className="tw-flex tw-justify-between tw-items-center tw-mb-6">
          <div className="tw-flex tw-items-center tw-gap-4">
            <div className="tw-relative">
              <input
                type="text"
                placeholder="Search"
                className="tw-pl-10 tw-pr-4 tw-py-2 tw-border tw-border-[#E9EAEB] tw-shadow tw-rounded-lg tw-w-64 tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-blue-500"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <img
                src={SearchIcon}
                alt="Search Icon"
                className="tw-absolute tw-left-3 tw-top-2.5 tw-h-5 tw-w-5 tw-text-gray-400"
              />
            </div>
            <div className="tw-flex tw-items-center tw-gap-2">
              <span className="tw-text-sm tw-font-normal tw-text-[#809199]">
                Rows per page
              </span>
              <div className="tw-relative">
                <button
                  className="tw-flex tw-justify-between tw-items-center tw-px-3 tw-py-1 tw-bg-transparent tw-border
                   tw-border-[#E9EAEB] tw-text-[#232323] tw-rounded-lg"
                  onClick={righttoggleDropdown}
                >
                  <div className="tw-flex tw-items-center">
                    <span className="tw-mr-3 tw-font-semibold tw-text-[#535862]">
                      {selectedRightValue}
                    </span>
                  </div>
                  <div>
                    <img
                      src={ArrowDownIcon}
                      alt="Arrow Down Icon"
                      className={`tw-w-4 tw-h-4 tw-transform ${
                        isRightOpen ? "tw-rotate-180" : "tw-rotate-0"
                      }`}
                    />
                  </div>
                </button>

                {isRightOpen && (
                  <div className="tw-absolute tw-right-0 tw-w-auto tw-bg-white tw-rounded-xl tw-shadow-lg tw-border-gray-200 tw-mt-1 tw-p-3">
                    <ul className="tw-py-1">
                      <button
                        className="tw-px-4 tw-py-2 tw-hover:bg-gray-100 tw-cursor-pointer"
                        onClick={() => righthandleOptionClick("1")}
                      >
                        1
                      </button>
                      <button
                        className="tw-px-4 tw-py-2 tw-hover:bg-gray-100 tw-cursor-pointer"
                        onClick={() => righthandleOptionClick("2")}
                      >
                        2
                      </button>
                      <button
                        className="tw-px-4 tw-py-2 tw-hover:bg-gray-100 tw-cursor-pointer"
                        onClick={() => righthandleOptionClick("3")}
                      >
                        3
                      </button>
                      <button
                        className="tw-px-4 tw-py-2 tw-hover:bg-gray-100 tw-cursor-pointer"
                        onClick={() => righthandleOptionClick("4")}
                      >
                        4
                      </button>
                      <button
                        className="tw-px-4 tw-py-2 tw-hover:bg-gray-100 tw-cursor-pointer"
                        onClick={() => righthandleOptionClick("5")}
                      >
                        5
                      </button>
                      <button
                        className="tw-px-4 tw-py-2 tw-hover:bg-gray-100 tw-cursor-pointer"
                        onClick={() => righthandleOptionClick("6")}
                      >
                        6
                      </button>
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="tw-flex tw-items-center tw-gap-4">
            <button
              onClick={() => navigate("/add-tier-configuration")}
              className="tw-bg-blue-600 hover:tw-bg-blue-700 tw-flex tw-items-center tw-gap-2 tw-text-white tw-rounded-md tw-px-4 tw-py-2 primary-custom-button"
            >
              <img src={PlusIcon} alt="Plus Icon" className="tw-w-5 tw-h-5" />
              Add
            </button>
          </div>
        </div>

        <div className="tw-bg-white tw-rounded-lg tw-border tw-border-[#E9EAEB] tw-shadow tw-overflow-hidden">
          <table className="tw-w-full">
            <thead>
              <tr className="tw-border-b">
                <th className="tw-px-6 tw-py-4 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862] tw-flex tw-items-center tw-gap-1">
                  Super Trader (T4)
                  <img
                    src={ArrowDown}
                    alt="Arrow Down"
                    className="tw-w-5 tw-h-5"
                  />
                </th>
                <th className="tw-px-6 tw-py-4 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                  <div className="tw-flex tw-items-center tw-gap-2">
                    TS Document
                    <img
                      src={ArrowDown}
                      alt="Arrow Down"
                      className="tw-w-5 tw-h-5"
                    />
                  </div>
                </th>
                <th className="tw-px-6 tw-py-4 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                  <div className="tw-flex tw-items-center tw-gap-2">
                    Created By
                    <img
                      src={ArrowDown}
                      alt="Arrow Down"
                      className="tw-w-5 tw-h-5"
                    />
                  </div>
                </th>
                <th className="tw-px-6 tw-py-4 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                  <div className="tw-flex tw-items-center tw-gap-2">
                    Created on Date & Time
                    <img
                      src={ArrowDown}
                      alt="Arrow Down"
                      className="tw-w-5 tw-h-5"
                    />
                  </div>
                </th>
                <th className="tw-px-6 tw-py-4 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                  <div className="tw-flex tw-items-center tw-gap-2">
                    Approved/Rejected By
                    <img
                      src={ArrowDown}
                      alt="Arrow Down"
                      className="tw-w-5 tw-h-5"
                    />
                  </div>
                </th>
                <th className="tw-px-6 tw-py-4 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                  <div className="tw-flex tw-items-center tw-gap-2">
                    Approval Status
                    <img
                      src={ArrowDown}
                      alt="Arrow Down"
                      className="tw-w-5 tw-h-5"
                    />
                  </div>
                </th>
                <th className="tw-px-6 tw-py-4 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="tw-divide-y tw-divide-gray-200">
              {currentData.map((tier, index) => (
                <tr key={index} className="tw-hover:bg-gray-50">
                  <td className="tw-px-6 tw-py-3 tw-text-sm font-weight-base font-primary-color">
                    {tier.supertrader}
                  </td>
                  <td className="tw-px-6 tw-py-3 tw-text-sm font-weight-base font-primary-color">
                    {tier.tsDocument}
                  </td>
                  <td className="tw-px-6 tw-py-3 tw-text-sm font-weight-base font-primary-color">
                    {tier.createdBy}
                  </td>
                  <td className="tw-px-6 tw-py-3 tw-text-sm font-weight-base font-primary-color">
                    {tier.createdOn}
                  </td>
                  <td className="tw-px-6 tw-py-3 tw-text-sm font-weight-base font-primary-color">
                    {tier.approvalStatus}
                  </td>
                  <td className="tw-px-6 tw-py-3 tw-text-sm">
                    <div className="tw-flex tw-items-center tw-gap-2">
                      <div>
                        <li
                          className={`tw-px-2 tw-py-1 tw-flex tw-items-center tw-gap-2 tw-rounded-full tw-text-sm tw-w-fit ${
                            tier.approvedBy === "Approved"
                              ? "tw-bg-[#ECFDF3] tw-text-[#027A48]"
                              : "tw-bg-[#F5F5F5] tw-text-[#414651]"
                          }`}
                        >
                          <span
                            className={`tw-w-2 tw-h-2 tw-rounded-full ${
                              tier.approvedBy === "Approved"
                                ? "tw-bg-[#12B76A]"
                                : "tw-bg-[#717680]"
                            }`}
                          ></span>
                          {tier.approvedBy}
                        </li>
                        <li
                          className={`tw-px-2 tw-py-1 tw-flex tw-items-center tw-gap-2 tw-rounded-full tw-text-sm tw-w-fit ${
                            tier.approvedBy === "Rejected"
                              ? "tw-bg-[#FDD4D2] tw-text-[#B54708]"
                              : "tw-bg-[#F5F5F5] tw-text-[#414651]"
                          }`}
                        >
                          <span
                            className={`tw-w-2 tw-h-2 tw-rounded-full ${
                              tier.approvedBy === "Rejected"
                                ? "tw-bg-[#B54708]"
                                : "tw-bg-[#717680]"
                            }`}
                          ></span>
                          {tier.approvedBy}
                        </li>
                      </div>
                      <button onClick={handleOpenRejectionReasonModal}>
                        <img
                          src={InfoIcon}
                          alt="Info Icon"
                          className="tw-w-5 tw-h-5"
                        />
                      </button>
                    </div>
                  </td>
                  <td className="tw-px-6 tw-py-3 tw-text-sm tw-flex tw-items-center tw-gap-4">
                    <button
                      onClick={() => navigate("/view-tier-configuration")}
                    >
                      <img
                        src={EyeIcon}
                        alt="Lock Icon"
                        className="tw-w-6 tw-h-6"
                      />
                    </button>
                    <button
                      onClick={() => navigate("/edit-tier-configuration")}
                    >
                      <img
                        src={EditIconBlue}
                        alt="Lock Icon"
                        className="tw-w-6 tw-h-6"
                      />
                    </button>
                    <button>
                      <img
                        src={CheckBlueIcon}
                        alt="Lock Icon"
                        className="tw-w-5 tw-h-5"
                      />
                    </button>
                    <button onClick={handleOpenRejectionModal}>
                      <img
                        src={CloseRedIcon}
                        alt="Lock Icon"
                        className="tw-w-5 tw-h-5"
                      />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="tw-flex tw-justify-between tw-items-center tw-mt-4">
          <div className="tw-text-sm font-gray-color">
            Page {currentPage} of {totalPages}
          </div>
          <div className="tw-flex tw-items-center tw-border tw-border-[#E9EAEB] tw-shadow tw-rounded-lg">
            <button
              className="tw-px-3 tw-py-1 tw-disabled:tw-opacity-50 tw-bg-white tw-rounded-tl-lg tw-rounded-bl-lg tw-overflow-hidden tw-text-sm tw-text-[#809199] font-weight-medium tw-flex tw-items-center tw-gap-2"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              <img
                src={ArrowLeftIcon}
                alt="Arrow Left Icon"
                className="tw-w-5 tw-h-5"
              />
              Previous
            </button>
            <span className="tw-bg-[#EDF3F7] tw-px-3 tw-py-1">
              {currentPage}
            </span>
            <button
              className="tw-px-3 tw-py-1 tw-disabled:tw-opacity-50 tw-bg-white tw-rounded-tr-lg tw-rounded-br-lg tw-overflow-hidden tw-text-sm tw-text-[#809199] font-weight-medium tw-flex tw-items-center tw-gap-2"
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Next
              <img
                src={ArrowRightIcon}
                alt="Arrow Right Icon"
                className="tw-w-5 tw-h-5"
              />
            </button>
          </div>
        </div>

        {/* Rejection Modal */}

        <div>
          {isRejectionModalOpen && (
            <TierConfigurationRejectionReason
              onClose={handleCloseRejectionModal}
              onSubmit={handleRejectionSubmit}
            />
          )}
        </div>
        <div>
          {isRejectionReasonModalOpen && (
            <TierRejectionReason
              onClose={handleCloseRejectionReasonModal}
              onSubmit={handleRejectionSubmit}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TierConfigurationModule;
